<template>
  <div class="module_main">
    <div class="mode1">
      <div class="tit">
        <template>
          <el-select v-model="lampsId" @change="selectChange">
            <el-option
              v-for="item in lamps"
              :key="item.lamp_id"
              :label="item.name"
              :value="item.lamp_id">
            </el-option>
          </el-select>
        </template>
      </div>
      <div class="to_day">
        <div class="w_icon">
          <img :src="require('../../assets/home_images/box3/weather/myicon/' + weatherData[0].wea_img +'.png')"/>
          <span>{{weatherData[0].wea}}</span>
        </div>
        <div class="temp">实时温度<br/>{{nowTemp}}℃</div>
      </div>
      <div class="week_day">
        <ul>
          <li v-for="(item,index) in (weatherData || '').slice(1)" :key="index"><!-- //做个空防止console.log报错 -->
            <p>
              <span>{{item.week}}</span>
              <img :src="require('../../assets/home_images/box3/weather/myicon/' + item.wea_img +'.png')"/>
              <em>{{item.tem2}}~{{item.tem1}}</em>
            </p>
          </li>
        </ul>
      </div>
      <div class="clear"></div>
    </div>
    <div class="mode2">
      <ul>
        <li>
          <div>
            <span><img src="@/assets/home_images/box3/qx_icon1.png" />温度</span>
            <h3>{{gasData[0].value}}<em>°C</em></h3>
          </div>
        </li>
        <li>
          <div>
            <span><img src="@/assets/home_images/box3/qx_icon2.png" />湿度</span>
            <h3>{{gasData[1].value}}<em>RH%</em></h3>
          </div>
        </li>
        <li>
          <div>
            <span><img src="@/assets/home_images/box3/qx_icon3.png" />PM2.5</span>
            <h3>{{gasData[2].value}}<em>μg/m3</em></h3>
          </div>
        </li>
        <li>
          <div>
            <span><img src="@/assets/home_images/box3/qx_icon4.png" />PM10</span>
            <h3>{{gasData[3].value}}<em>μg/m3</em></h3>
          </div>
        </li>
        <li>
          <div>
            <span><img src="@/assets/home_images/box3/qx_icon5.png" />光照度</span>
            <h3>{{gasData[4].value}}<em>lux</em></h3>
          </div>
        </li>
        <li>
          <div>
            <span><img src="@/assets/home_images/box3/qx_icon6.png" />风速</span>
            <h3>{{gasData[6].value}}<em>m/s</em></h3>
          </div>
        </li>
        <li class="win">
          <div>
            <span><img src="@/assets/home_images/box3/qx_icon7.png" />风向</span>
            <h3>{{nowWin}}<em></em></h3>
          </div>
        </li>
        <li>
          <div>
            <span><img src="@/assets/home_images/box3/qx_icon8.png" />噪声</span>
            <h3>{{gasData[5].value}}<em>db</em></h3>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import homeApi from "@/api/home/index";
export default {
  name: 'Box3',
  props: {
    itemData: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    lamp_name: {
      type: String,
      required: true,
      default: function () {
        return '默认灯杆'
      }
    },
    lamp_id: {
      type: Number,
      required: true,
      default: function () {
        return 705
      }
    }
  },
  data() {
    return {
      weatherData: [{
        day: "9日（今天）",
        week: "星期四",
        wea: "阴",
        wea_img: "yin",
        air: 58,
        humidity: 70,
        air_level: "良",
        tem1: "6℃",
        tem2: "3℃",
        tem: "3℃",
        win_speed: "<3级",
        hours: [
          {
            day: "09日20时",
            wea: "阴",
            tem: "3℃",
            win: "东北风",
            win_speed: "<3级"
          },
          {
            day: "09日20时",
            wea: "阴",
            tem: "3℃",
            win: "东北风",
            win_speed: "<3级"
          },
          {
            day: "09日20时",
            wea: "阴",
            tem: "3℃",
            win: "东北风",
            win_speed: "<3级"
          },
          {
            day: "09日20时",
            wea: "阴",
            tem: "3℃",
            win: "东北风",
            win_speed: "<3级"
          },
          {
            day: "09日20时",
            wea: "阴",
            tem: "3℃",
            win: "东北风",
            win_speed: "<3级"
          }
        ],
        index: []
      }],
      gasData:[
        {value:0},
        {value:0},
        {value:0},
        {value:0},
        {value:0},
        {value:0},
        {value:0},
        {value:0}
      ],
      lampsId: this.lamp_id,
      lamps: [],
      nowTemp: 0,
      nowWin: 0,
      timer: null,
      
    }
  },
  watch: {
    itemData: function(newVal){
      if(newVal.length>0){
        this.gasData = newVal;
        newVal && this.getData();  
      }
    },
    lamp_id: function(newVal){
      if(newVal){
        this.lampsId = newVal 
      }
    }
  },
  methods: {
    getlampList() {
      homeApi.homeLampListData().then((res) => {
        if (res.data.code === 1000) {
          this.lamps = res.data.data;
        }
      });
    },
    selectChange(value) {
      if (value) {
        homeApi.homeLampData(value).then((res) => {
          // console.log('selectChange',res.data.data)
          if (res.data.code === 1000) {
            let rep_data = res.data.data;
            // console.log('rep_data',rep_data)
            if(rep_data.length>0){
              let gas_data = ['北风','东北风','东风','东南风','南风','西南风','西风','西北风']
              for (let i=0;i<rep_data.length;i++){
                if(i==7){
                  this.gasData[i].value=gas_data[Number((rep_data[i].value).substr(1,1))];
                }else{
                  this.gasData[i].value=rep_data[i].value
                }
              }
            }else{
              this.gasData = [
                {value:0},
                {value:0},
                {value:0},
                {value:0},
                {value:0},
                {value:0},
                {value:0},
                {value:0}
              ] 
            }
          }
        });
      } else {
        return value;
      }
    },
    getData() {
      let rep_data = this.gasData
      // console.log('rep_data',rep_data)
      if(rep_data.length>0){
        let gas_data = ['北风','东北风','东风','东南风','南风','西南风','西风','西北风']
        for (let i=0;i<rep_data.length;i++){
          if(i==7){
            // console.log('n7',rep_data[i].name)
            this.gasData[i].value=gas_data[Number((rep_data[i].value).substr(1,1))];
          }else{
            // console.log('n'+i,rep_data[i].name)
            this.gasData[i].value=rep_data[i].value
          }
        }
      }
    },
    getWeather() {
      let that = this
      axios({
        method: 'get',
        url: 'https://www.tianqiapi.com/api?version=v1&appid=16968894&appsecret=yd5J2UaB'
      }).then(function(res) {
        that.weatherData = res.data.data
      })
    },
    getNowTemp() {
      let that = this
      axios({
        method: 'get',
        url: 'https://www.tianqiapi.com/free/day?version=v1&appid=16968894&appsecret=yd5J2UaB'
      }).then(function(res) {
        that.nowTemp = res.data.tem
        that.nowWin = res.data.win
      })
    }
  },
  mounted() {
    this.getlampList()
    this.getWeather()
    this.getNowTemp()
    if (this.timer) {
      clearInterval(this.timer)
    } else {
      this.timer = setInterval(() => {
        setTimeout(this.getNowTemp(), 0)
      }, 60 * 1000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  }
};
</script>
<style lang='less' scoped>
.module_main {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background: none;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  
  .mode1 {
    width: 567px;
    height: 127px;
    box-sizing: border-box;
    background-image:url('../../assets/home_images/box3/wea_bg.png');
    background-position:center center;
    background-size:100% 100%;
    .tit {
      padding:0 0 0 10px;
      width:173px;
      height:30px;
      line-height:30px;
      box-sizing: border-box;
      overflow: hidden;
      text-align:center
      span{
        color:#333;
        font-size:16px;
      }
    }

    .to_day {
      width: 33.51%;
      height:96px;
      float: left;
      position: relative;
      .w_icon {
          width: 49%;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          text-align: center;
          color: #fff;
          font-size: 14px;
          line-height: 1.2;
        }

        .w_icon img {
          max-width: 50%;
        }
        .w_icon span {
          display: block;
          padding-top: 2px;
        }

        .temp {
          width: 49%;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          text-align: center;
          color: #fff;
          font-size: 14px;
          line-height:1.5;
          border-left: 1px solid #2b499c;
          padding: 10px 0;
        } 
    }

    .week_day {
      width: 66.49%;
      float: right;
      position: relative;
      margin-top:24px;
      height: 60px;
      ul {
        width: 100%;
        height: 60px;
        box-sizing: border-box;
        padding:0;
        list-style: none;
        margin:0;
        li {
          width: 16.6666%;
          float: left;
          height: 100%;
          border-right: 1px solid rgba(255,255,255,.1);
          box-sizing: border-box;
          text-align: center;
          position: relative;
          overflow: hidden;
          p {
            position: absolute;
            width: 100%;
            text-align: center;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            color: rgba(255,255,255,.7);
            font-size: 11px;
            overflow: hidden;
            margin:0;
            img {
              max-width:45%;
            }
            span,em {
              display: block;
              font-style: normal;
            }
            em {
              font-size: 11px;
            }
          }
        }
      }
    }
  }
  
}



.mode2 {
  width: 100%;
  height: 64px;
  box-sizing: border-box;
  margin-top:15px;
  ul{
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    li{
      position: relative;
      width:12.5%;
      float:left;
      height:100%;
      div{
        position:absolute;
        left:0;
        width:100%;
        text-align: center;
        color:#fff;
        top: 50%;
        transform: translateY(-50%);
        font-size:12px;
        border-right:1px solid rgba(255,255,255,.1);
        box-sizing: border-box;
        span{
          display: block;
          color:#fff;
          img{
            vertical-align:middle;
            width:24px;
            height:24px;
            margin-right: 3px;
          }
        }
        h3{
          display: block;
          font-size:16px;
          margin:0;
          padding:0;
          margin-top:5px;
          color:#a6d3e9;
          font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
          font-style: normal;
          em{
            font-size:12px;
            font-style: normal;
            margin-left: 3px;
            color:rgba(255,255,255,.7);
            font-family: Arial, Helvetica, sans-serif;
          }
        }
      }
    }
    .win{
      h3{
        font-weight: normal;
        font-size:14px;
      }
    }
    li:last-child div{
      border-right:none;
    }
  }
}

</style>
<style lang='less'>
.mode1{
  .el-input--mini .el-input__inner, .el-input__inner{
    height:30px !important;
    line-height:30px !important;
    border:none !important;
    background: none !important;
    border-radius: 0;
    color:#333;
    font-size:16px;
    padding:0;
    padding-right:25px;
    text-align: center;
  }
  .el-select .el-input .el-select__caret{
    color:#333;
  }
}
</style>